import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { XIcon } from 'lucide-react';
interface TermsPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export const TermsPopup: React.FC<TermsPopupProps> = ({
  open,
  onOpenChange
}) => {
  return <Dialog.Root open={open} onOpenChange={onOpenChange} data-id="element-209">
      <Dialog.Portal data-id="element-210">
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-40" data-id="element-211" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-6 max-w-md w-full max-h-[85vh] overflow-y-auto z-50" data-id="element-212">
          <div className="flex justify-between items-start mb-4" data-id="element-213">
            <Dialog.Title className="text-xl font-medium text-[#444]" data-id="element-214">
              Términos y Condiciones
            </Dialog.Title>
            <Dialog.Close asChild data-id="element-215">
              <button className="text-[#8e7f7a] hover:text-[#444]" data-id="element-216">
                <XIcon size={20} data-id="element-217" />
              </button>
            </Dialog.Close>
          </div>
          <div className="space-y-4 text-[#5a5553]" data-id="element-218">
            <h3 className="font-medium" data-id="element-219">1. Introducción</h3>
            <p data-id="element-220">
              Estos Términos y Condiciones regulan el uso del ebook "Autocuidado
              en el Postparto" y los materiales complementarios ofrecidos. Al
              realizar la compra, aceptas estos términos en su totalidad.
            </p>
            <h3 className="font-medium" data-id="element-221">2. Propiedad Intelectual</h3>
            <p data-id="element-222">
              Todo el contenido, incluyendo textos, imágenes, gráficos, y
              diseños son propiedad exclusiva nuestra y están protegidos por
              leyes de propiedad intelectual. No está permitida la reproducción,
              distribución, o venta de estos materiales.
            </p>
            <h3 className="font-medium" data-id="element-223">3. Uso Personal</h3>
            <p data-id="element-224">
              La compra otorga una licencia personal, no transferible y no
              exclusiva para acceder y utilizar los materiales para uso personal
              únicamente. No está permitido compartir los accesos o contenidos
              con terceros.
            </p>
            <h3 className="font-medium" data-id="element-225">4. Política de Devoluciones</h3>
            <p data-id="element-226">
              Debido a la naturaleza digital de los productos, no ofrecemos
              reembolsos una vez completada la compra y recibido el acceso a los
              materiales digitales.
            </p>
            <h3 className="font-medium" data-id="element-227">5. Exención de Responsabilidad</h3>
            <p data-id="element-228">
              La información proporcionada tiene fines educativos e informativos
              únicamente y no constituye asesoramiento médico profesional.
              Consulta siempre a profesionales de la salud calificados para
              cualquier condición médica.
            </p>
            <h3 className="font-medium" data-id="element-229">6. Modificaciones</h3>
            <p data-id="element-230">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación.
            </p>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>;
};